import { chatInitState, chatReducers } from "./reducer";
import { createSlice } from "@reduxjs/toolkit";

export const SLICE_NAME = "chat";

export const chatState = createSlice({
  name: SLICE_NAME,
  initialState: chatInitState,
  reducers: chatReducers,
});

export const ACTIONS = chatState.actions;
export default chatState.reducer;
